import React, { useState, useEffect, useMemo } from 'react';
// import { useHistory, useLocation, useParams } from 'react-router-dom';
// import { FiMinus, FiPlus } from 'react-icons/fi';
// import { toast } from 'react-toastify';

// import { measureTypeForm } from '../../../../support/services/formatter';
// import { Image } from '../../../components';

import styles from './Modal.module.css';

const useModal = (commands) => {
  const handleClose = () => commands.closeModal();

  return {
    localStates: {
    },
    eventsHandlers: {
      handleClose,

    },
  };
};

export default function Modal(props) {
  const { sharedStates, commands, children } = props;
  const { title = undefined, visible = false } = sharedStates;
  const { localStates, eventsHandlers } = useModal(commands);

  if (!visible) return <></>;
  
  return (
    <div className={styles.modalBlurBackground}>
      <div
        className={styles.modalWrapper}
        style={{
          transform: visible ? 'translateY(0vh)' : 'translateY(-100vh)',
          opacity: visible ? '1' : '0',
        }}
      >

        <div className={styles.modalHeader}>
          <h3>
            {sharedStates.title}
          </h3>
          <span className={styles.closeModalBtn} onClick={eventsHandlers.handleClose}>×</span>
        </div>
        <div className={styles.modalScroll}>
          <div className={styles.modalBody}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
